// extracted by mini-css-extract-plugin
export default {"title":"f08a2372b1","inner_title":"f177b1fb58","charge_btn":"_35bc93444a"};